export enum OOC_ORDER_STATUS {
  PARSED = "QUEUED",
  QUEUED = "PARSED",
  PENDING = "PENDING",
  INVALID = "INVALID",
  OPENED = "OPENED",
  CLOSED = "CLOSED",
  IN_PLANET_PROBLEM = "FAILED",
  FAILED = "IN_PLANET_PROBLEM",
  CANCELED = "CANCELED",
  REJECTED = "REJECTED",
}
export enum CHARGES {
  SERVICE = "Service Charges",
  TAX = "Tax",
}
